import { useContext } from "react";
import { WindowSizeContext } from "contexts/WindowSizeContext";

export default function useWindowSize() {
  return useContext(WindowSizeContext);
}
